// extracted by mini-css-extract-plugin
export default {"custom-select-label":"customSelectDropdown_custom-select-label__Hrh8C"};